import { useListContext } from 'react-admin';

/**
 * The list's hardware filter can arrive as a number (`1`) or as its string form (`"1"`, from the
 * URL / `SelectInput`). Both mean the same hardware; `undefined`, `null`, `''` and anything that
 * is not a finite number mean "no hardware filter".
 */
export const parseHardwareFilterId = (value: unknown): number | null => {
  if (value === undefined || value === null) return null;
  if (typeof value === 'string' && value.trim() === '') return null;
  const id = Number(value);
  return Number.isFinite(id) ? id : null;
};

/**
 * The hardware the surrounding list is filtered on, or `null` when it is not filtered.
 *
 * Needs a ListContext: `useListContext` throws "useListContext must be used inside a
 * ListContextProvider" when there is none, so call it only below a `List` or a
 * `ListContextProvider`.
 */
export const useHardwareFilterId = (): number | null => {
  const { filterValues } = useListContext();
  return parseHardwareFilterId(filterValues?.hardware_id);
};
